import { Entity } from '../../services/restService';

export enum SessionStatus {
    Planned = "planned",
    Prepared = "prepared",
    Draft = "draft",
    Completed = "completed"
}

export interface Session extends Entity {
    id?: string
    clientId: string
    name: string
    calendarEventId?: string
    startTime: Date
    endTime: Date
    duration?: number
    location?: string
    remarks?: string[]
    notes?: string[]
    objective?: string
    keyInsights?: string
    methodsUsed?: string[]
    status: SessionStatus
    attachments?: number
    creator?: string
    createdDate?: Date
    updatedDate?: Date
    archived?: boolean
}
